var accordionCount = 1;

document.querySelectorAll(".accordion").forEach(accordion => {
  const trigger = accordion.querySelector(".accordion__trigger");
  const body = accordion.querySelector(".accordion__body");

  if (trigger) {
    trigger.setAttribute("id", "accordionTrigger" + accordionCount);
    trigger.setAttribute("aria-controls", "accordionBody" + accordionCount);
  }

  if (body) {
    body.setAttribute("id", "accordionBody" + accordionCount);
    body.setAttribute("aria-labelledby", "accordionTrigger" + accordionCount);
  }

  accordionCount++;
});

function slideUp(el) {
  el.style.height = el.scrollHeight + "px";
  el.style.overflow = "hidden";
  el.style.transition = "height 200ms ease";
  el.offsetHeight; // force reflow
  el.style.height = "0";
  el.addEventListener("transitionend", () => {
    el.style.display = "none";
    el.style.height = "";
    el.style.overflow = "";
    el.style.transition = "";
  }, { once: true });
}

function slideDown(el) {
  el.style.display = "block";
  el.style.height = "0";
  el.style.overflow = "hidden";
  el.style.transition = "height 200ms ease";
  el.offsetHeight; // force reflow
  el.style.height = el.scrollHeight + "px";
  el.addEventListener("transitionend", () => {
    el.style.height = "";
    el.style.overflow = "";
    el.style.transition = "";
  }, { once: true });
}

document.body.addEventListener("click", e => {
  const trigger = e.target.closest(".accordion__trigger");
  if (!trigger) return;

  const parent = trigger.closest(".accordion");
  const body = parent.querySelector(".accordion__body");

  if (parent.classList.contains("expanded")) {
    trigger.setAttribute("aria-expanded", "false");
    slideUp(body);
  } else {
    trigger.setAttribute("aria-expanded", "true");
    slideDown(body);
  }

  parent.classList.toggle("expanded");
});
